import { forwardRef } from 'react';
import { Calendar } from 'assets/icons';
import StyledInput from './StyledInput';

// react-datepicker's `customInput`: the picker clones this element with its own
// handlers and a ref it needs on the real <input> (focus, blur, outside clicks).
// `className` carries the picker's "ignore outside click" class while it is open,
// so it lands on the field wrapper, an ancestor of the input.
const StyledDateInput = forwardRef(
  (
    {
      label,
      value,
      onClick,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      placeholder,
      disabled,
      className,
    },
    ref,
  ) => (
    <StyledInput
      type={'text'}
      label={label}
      inputRef={ref}
      value={value}
      onClick={onClick}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      isDisabled={disabled}
      className={className}
      imgFront={<Calendar wh={18} color={'#666666'} />}
    />
  ),
);

StyledDateInput.displayName = 'StyledDateInput';

export default StyledDateInput;
